import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

/**
 * 获取总包单位下拉列表
 * */
export function getGeneralContractorList(data){
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dept/list`,
        method: 'post',
        data
    })
}

/**
 * 获取总单位负责人下拉列表
 */
export function getGeneralContractorContactList(data){
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/list`,
        method: 'post',
        data
    })
}

/**
 * 获取部门列表
 */
export function getDeptList(data){
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dept/list`,
        method: 'post',
        data
    })
}